export const navigationTypes = {
    SET_PENDING_ROUTE: 'SET_PENDING_ROUTE',
    PENDING_ROUTE_COMPLETE: 'PENDING_ROUTE_COMPLETE',
}
